<script lang="ts" setup>
import { useRouter } from 'vue-router'
import { useSettingsStore } from '@/modules/settings/store/settingsStore'
import SupportButton from '@/components/support-button/SupportButton.vue'
import { ERouteNames } from '@/router/ERouteNames'
import { version } from '@/version'
import ServiceWorks from '@/components/ServiceWorks.vue'
import ufo from '@/assets/icons/404.png'
import { useDisplay } from 'vuetify'
import { useI18n } from 'vue-i18n'

const settingsStore = useSettingsStore()
const router = useRouter()
const { mobile } = useDisplay()
const { t } = useI18n()

const goHome = () => {
  router.push({ name: ERouteNames.HOME })
}
</script>

<template>
  <v-container fluid class="d-flex flex-column align-center justify-space-evenly ga-2 h-100" :class="mobile ? 'pa-4' : 'py-4 px-0'">
    <service-works v-if="settingsStore.showGlobalNotification && settingsStore.notificationText" />

    <v-img :src="ufo" width="315" height="300" alt="404" max-height="300" contain />

    <div class="text-center">
      <h1 class="text-h1">404</h1>
      <p class="text-h4">{{ t('common.pageNotFound') }}</p>
    </div>

    <div class="d-flex flex-column ga-6 w-100">
      <v-btn
        color="primary"
        variant="flat"
        rounded="lg"
        block
        @click="goHome"
      >
        {{ t('common.backToHome') }}
      </v-btn>

      <support-button />
    </div>

    <footer class="d-flex align-center w-100 justify-end">
      <span class="text-micro">v {{ version }}</span>
    </footer>
  </v-container>
</template>
